module.exports = __webpack_public_path__ + "static/media/38.a65e97c2.mp3";